import type { ReactNode, Ref } from 'react'
import React from 'react'
import classNames from 'classnames'

import './styles.css'

export type SidebarSectionProps = {
  title?: ReactNode
  rightPart?: ReactNode
  isExpanded?: boolean
  onToggleExpand?: () => void
  isSticky?: boolean
  className?: string
  sectionRef?: Ref<HTMLElement>
  children: ReactNode
}

const BASE_CLASSNAME =
  'flexbox flexbox-align-center flexbox-grow padding-left-8 padding-vertical-8 background-transparent border-none shade-20 font-weight-semibold font-size-large sidebar-section-header-button'

export function SidebarSection({
  title,
  rightPart,
  isExpanded,
  onToggleExpand,
  isSticky,
  className,
  sectionRef,
  children,
}: SidebarSectionProps) {
  const hasHeader = Boolean(title || rightPart)
  const shouldStick = isSticky ?? hasHeader
  const isExpandable = isExpanded !== undefined

  const labelNode = title && <span>{title}</span>

  return (
    <section
      ref={sectionRef}
      className={classNames('sidebar-section', className)}
    >
      {hasHeader && (
        <div
          className={classNames(
            'sidebar-section-header flexbox flexbox-align-center flexbox-space-between',
            { 'sidebar-section-header--sticky': shouldStick }
          )}
        >
          {isExpandable ? (
            <button
              type="button"
              onClick={onToggleExpand}
              className={classNames(
                BASE_CLASSNAME,
                'shade-00-on-hover cursor-pointer'
              )}
            >
              {labelNode}
            </button>
          ) : (
            <div className={BASE_CLASSNAME}>{labelNode}</div>
          )}
          {rightPart}
        </div>
      )}

      {(!isExpandable || isExpanded) && (
        <div className="padding-horizontal-12">{children}</div>
      )}
    </section>
  )
}
